import config from '../config';
import { loadCountries, loadCountriesFailed, loadStates, loadStatesFailed } from '../actions/geo';
import fetch from 'cross-fetch';
import store from 'store2';
import { addNotification as notify } from 'reapop';

export function fetchCountries() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/geo/countries`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadCountries({
              countries: json
            }));
          }
        })
        .catch(response => dispatch(loadCountriesFailed({ error: response })));
    }
  }
};

export function fetchStates(countryId) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/geo/states/${countryId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `bearer ${userAuth.api_token}`
        },
        credentials: 'same-origin'
      })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadStates({
              statesCountryId: countryId,
              states: json
            }));
          }
        })
        .catch(response => dispatch(loadStatesFailed({ error: response })));
    }
  }
};


// WEBPACK FOOTER //
// ./src/api/geo.js